import { Preference } from '@marmon/frontend/common';
import { coerceCurrency, Currency } from '@marmon/shared/types/common';

const AnalysisCurrencyPreference = new Preference('analysis.currency');

/**
 * Last currency the user selected. Unsupported or invalid stored values
 * fall back to USD.
 */
export function readPreferredCurrency(): Currency {
	return coerceCurrency(AnalysisCurrencyPreference.get());
}

export function savePreferredCurrency(currency: unknown) {
	AnalysisCurrencyPreference.set(coerceCurrency(currency));
}
